import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

const Header = () => {
  const [activeLink, setActiveLink] = useState('home');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'about', 'WhyChoose', 'our-activity-section', 'address-section']; // IDs of your sections
      let currentActive = 'home'; // Default to home if no section is active

      for (let i = sections.length - 1; i >= 0; i--) {
        const sectionId = sections[i];
        const section = document.getElementById(sectionId);

        if (section) {
          // Adjust offset based on header height or desired activation point
          const sectionTop = section.offsetTop - 100;
          const sectionBottom = sectionTop + section.offsetHeight;

          if (window.scrollY >= sectionTop && window.scrollY < sectionBottom) {
            currentActive = sectionId;
            break;
          }
        }
      }
      setActiveLink(currentActive);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Call once on mount to set initial active link

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []); // Removed dependency on location.state as scroll handling is in App.jsx


  const handleNavLinkClick = (e, sectionId) => {
    e.preventDefault(); // Prevent default anchor link behavior

    if (location.pathname !== '/') {
      // If not on the home page, navigate to home and pass the sectionId in state
      navigate('/', { state: { scrollToId: sectionId } });
    } else {
      // If already on the home page, just scroll
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
        setActiveLink(sectionId); // Update active link immediately on click
      }
    }
  };

  return (
    <header className="fbs__net-navbar navbar navbar-expand-lg dark" aria-label="freebootstrap.net navbar">
        <div className="container d-flex align-items-center justify-content-between">


            {/* Start Logo*/}
            <Link className="navbar-brand w-auto" to="/">
                {/* If you use a text logo, uncomment this if it is commented*/}
                {/* Vertex*/}

                {/* If you plan to use an image logo, uncomment this if it is commented*/}

                {/* logo dark*/}<img className="logo dark img-fluid" src="/assets/images/Sports_Logo.png" alt="FreeBootstrap.net image placeholder" />

                {/* logo light*/}<img className="logo light img-fluid" src="/assets/images/Sports_Logo.png" alt="FreeBootstrap.net image placeholder" />

            </Link>
            {/* End Logo*/}

            {/* Start offcanvas*/}
            <div className="offcanvas offcanvas-start w-75" id="fbs__net-navbars" tabIndex={-1} aria-labelledby="fbs__net-navbarsLabel">


                <div className="offcanvas-header d-flex justify-content-between align-items-center">
                    <div className="offcanvas-header-logo">
                        {/* If you use a text logo, uncomment this if it is commented*/}

                        {/* h5#fbs__net-navbarsLabel.offcanvas-title Vertex*/}

                        {/* If you plan to use an image logo, uncomment this if it is commented*/}
                        <Link className="logo-link" id="fbs__net-navbarsLabel" to="/">


                            {/* logo dark*/}<img className="logo dark img-fluid" src="/assets/images/Sports_Logo.png" alt="FreeBootstrap.net image placeholder" />

                            {/* logo light*/}<img className="logo light img-fluid" src="/assets/images/Sports_Logo.png" alt="FreeBootstrap.net image placeholder" /></Link>

                    </div>
                    <button className="btn-close btn-close-black" type="button" data-bs-dismiss="offcanvas" aria-label="Close" />
                </div>

                <div className="offcanvas-body align-items-lg-center">


                    <ul className="navbar-nav nav me-auto ps-lg-5 mb-2 mb-lg-0">
                        <li className="nav-item"><a className={`nav-link scroll-link ${activeLink === 'home' ? 'active' : ''}`} aria-current="page" href="#home" onClick={(e) => handleNavLinkClick(e, 'home')}>Home</a></li>
                        <li className="nav-item"><a className={`nav-link scroll-link ${activeLink === 'about' ? 'active' : ''}`} href="#about" onClick={(e) => handleNavLinkClick(e, 'about')}>About Us</a></li>
                        <li className="nav-item"><a className={`nav-link scroll-link ${activeLink === 'WhyChoose' ? 'active' : ''}`} href="#WhyChoose" onClick={(e) => handleNavLinkClick(e, 'WhyChoose')}>Why Trained With Us</a></li>
                        <li className="nav-item"><a className={`nav-link scroll-link ${activeLink === 'our-activity-section' ? 'active' : ''}`} href="#our-activity-section" onClick={(e) => handleNavLinkClick(e, 'our-activity-section')}>Our Program</a></li>
                        <li className="nav-item"><a className={`nav-link scroll-link ${activeLink === 'address-section' ? 'active' : ''}`} href="#address-section" onClick={(e) => handleNavLinkClick(e, 'address-section')}>Contact Us</a></li>



                    </ul>

                </div>
            </div>
            {/* End offcanvas*/}

            <div className="ms-auto w-auto">


                <div className="header-social d-flex align-items-center gap-1"><Link className="btn btn-primary py-2" to="/form"> Enroll Now</Link>

                    <button className="fbs__net-navbar-toggler justify-content-center align-items-center ms-auto" data-bs-toggle="offcanvas" data-bs-target="#fbs__net-navbars" aria-controls="fbs__net-navbars" aria-label="Toggle navigation" aria-expanded="false">
                        <svg className="fbs__net-icon-menu" xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                            <line x1={21} x2={3} y1={6} y2={6} />
                            <line x1={15} x2={3} y1={12} y2={12} />
                            <line x1={17} x2={3} y1={18} y2={18} />
                        </svg>
                        <svg className="fbs__net-icon-close" xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                            <path d="M18 6 6 18" />
                            <path d="m6 6 12 12" />
                        </svg>
                    </button>

                </div>

            </div>
        </div>
    </header>
  );
};

export default Header;
